import {
    buildTeamLogoOptions,
    getDefaultValue,
    getLogoUrl,
    getTeamLogoUrlByTeamId
} from '@draftkings/sportsbook-common-utils';
import { TeamLogoOptions } from '@draftkings/sportsbook-common-contracts';
import { LogosMap } from '../../contracts';
import { ContractTypes } from '@draftkings/dk-data-layer';

export const getTeamLogo = (
    participant: ContractTypes.Participant,
    logosTeam: LogosMap['Teams'] | undefined,
    staticS3Host: string,
    swooshBaseUrl: string,
    isSwooshTeamLogosEnabledForSportSlider: boolean
): string => {
    const options: TeamLogoOptions = buildTeamLogoOptions('sm', 'dark', participant.venueRole);
    const teamId = participant.metadata?.rosettaTeamId || participant.id;

    return isSwooshTeamLogosEnabledForSportSlider
        ? getDefaultValue(getTeamLogoUrlByTeamId(swooshBaseUrl, teamId, options)?.toString(), '')
        : getDefaultValue(getLogoUrl(staticS3Host, logosTeam, participant.name), '');
};
